<button mat-icon-button (click)="show()" matTooltip="Anfrage stellen" *ngIf="!asbutton">
  <svg-icon>frage</svg-icon>
</button>

<button mat-button (click)="show()" matTooltip="Anfrage stellen" *ngIf="asbutton">
  <svg-icon>frage</svg-icon>
</button>
